const DEFAULT_STATE = {
  data: {},
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getData: (state) => state.data,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setData(state, payload) {
      state.data = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    setData(context, payload) {
      context.commit("setData", payload);
    },
  },
};
